import {gsap} from 'gsap';
import {Draggable} from 'gsap/Draggable';

gsap.registerPlugin(Draggable);

export default function SliderScrollbar(Splide, Components) {
  const {Slides} = Components;

  let scrollbar;
  let knob;
  let area;
  let instance;
  const min = 0;
  const max = 100;
  const values = [];

  function mount() {
    scrollbar = Splide.root.querySelector('.splide__scrollbar');

    if (!scrollbar) return;

    knob = scrollbar.querySelector('.knob');
    area = scrollbar.querySelector('.area');

    if (scrollbar && knob && area) {
      const amountOfValues = Slides.get().length - Splide.options.perPage + 1;

      for (let i = 0; i < amountOfValues; i++) {
        values.push(max / (amountOfValues - 1) * i);
      }

      knob.style.width = max / amountOfValues  + '%';

      instance = new Draggable(knob, {
          type: 'x',
          edgeResistance: 1,
          bounds: area,
          throwProps: false,
          onDragEnd: function () {
            handleInputslider(true);
          },
        }
      );

      resolveScrollbarStatus();
      Splide.on( 'move', onMove );
    }
  }

  function resolveScrollbarStatus() {
    const { options } = Splide;
    let isScrollbarActive = true;

    Array.from(options.breakpoints).forEach((val, breakpointWidth) => {
      const isActive = breakpointWidth <= window.innerWidth;

      if(isActive && !val.scrollbar) {
        isScrollbarActive = false;
        return;
      }
    });

    if(!isScrollbarActive || isScrollbarActive && !options.scrollbar) {
      scrollbar.classList.add('hidden');
    }
  }

  function update(finalSectionIndex) {
    Splide.go(finalSectionIndex);
  }

  function onMove(index) {
    drag(index);
  }

  function drag(index) {
    const finalValue = gsap.utils.snap(values, values[index]),
      x = gsap.utils.mapRange(min, max, 0, area.clientWidth - knob.clientWidth, finalValue);

    gsap.to(instance.target, {duration: .2, x});
  }

  function handleInputslider(snap) {
    const relativeValue = gsap.utils.mapRange(0, instance.maxX, min, max, instance.x),
      finalValue = gsap.utils.snap(values, relativeValue),
      snapX = gsap.utils.mapRange(min, max, 0, instance.maxX, finalValue),
      finalSectionIndex = values.findIndex(val => val === finalValue);

    if (snap)
      gsap.to(instance.target, {duration: .2, x: snapX})
        .then(() => {
          update(finalSectionIndex);
        });
  }

  function getScrollbar() {
    return scrollbar;
  }

  return {
    mount, drag, getScrollbar,
  };
}
